import { useCallback } from 'react'

import { useGoToAddCardStage } from 'hooks/useGoToAddCardStage/useGoToAddCardStage'
import {
  AddCardStage,
  CardTypeOption,
} from 'hooks/useGoToAddCardStage/useGoToAddCardStage.types'
import { ROOT } from 'const/routes'

export const useCorporateCardStartupModal = () => {
  const { goToAddCardStage } = useGoToAddCardStage()

  const handleCreateCard = useCallback(async () => {
    goToAddCardStage(
      {
        stage: AddCardStage.CreateSelectCardTypeStage,
        cardType: CardTypeOption.ExpenseCard,
      },
      ROOT.PORTAL.CARDS.CORPORATE.path
    )
  }, [goToAddCardStage])

  return { handleCreateCard }
}
